import { StyledH2 } from "@aureskonnect/react-ui";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";
import { setLicenceGodia, setLoyaltyAccount } from "../store";
import { Input } from "reactstrap";

export default function LoyaltyAccount({ selectedRows }: any) {
    const { t } = useTranslation();

    const isActivation = selectedRows[0]?.ActivationLoyaltyAccount ?? false;
    const [isAuthorized, setIsAuthorized] = React.useState<boolean>(
        selectedRows[0]?.Autorisation ?? false
    );

    const licenceGodiaData =
        selectedRows[0]?.["composite Products"]?.licenceGodia;
    const [godia, setGodiaState] = React.useState(() => ({
        ActivationGodia: licenceGodiaData?.ActivationGodia ?? 0,
        licenceGodia: licenceGodiaData?.licenceGodia ?? "",
        Paramavantages: licenceGodiaData?.Paramavantages ?? 1,
    }));

    const sofaveraActivation = (): boolean => {
        return (
            isActivation &&
            (Object.keys(godia).length === 0 || godia.ActivationGodia === 0)
        );
    };

    const handleGodiaParamChange = (checked: number) => {
        const updatedGodia = {
            ...godia,
            Paramavantages: checked,
        };
        setGodiaState(updatedGodia);
    };
    const handleInterconnectionKey = (text: string) => {
        const updatedGodia = {
            ...godia,
            licenceGodia: text,
        };
        setGodiaState(updatedGodia);
    };
    const isValid = /^[A-F0-9]{5}-[A-F0-9]{5}-[A-F0-9]{5}-[A-F0-9]{5}$/.test(
        godia.licenceGodia
    );
    useEffect(() => {
        setLoyaltyAccount({ isAuthorized });
        setLicenceGodia(godia);
    }, [isAuthorized, godia]);
    return (
        <React.Fragment>
            <StyledH2
                style={{
                    font: "normal normal 600 30px/41px Nunito Sans",
                    color: "#000000",
                    opacity: "1",
                }}
                className="ml-5 pt-3"
            >
                {t("Loyalty account")}
            </StyledH2>

            <div className="d-flex align-items-center justify-content-between">
                <StyledH2
                    style={{
                        font: "normal normal 600 20px/27px Nunito Sans",
                        color: "#000000",
                        opacity: "1",
                    }}
                    className="ml-5 pt-3"
                >
                    {t("Softavera loyalty")}
                </StyledH2>
                <div className="float-right mr-4 cac_icn_loyaltyAccountActivation">
                    <ReactSwitch
                        disabled={true}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={sofaveraActivation()}
                        onChange={() => {}}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                    />
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3 ml-3 px-5">
                <div className="ml-5">
                    {t("Activation of the loyalty account")}
                </div>
                <div className="float-right mr-4 cac_icn_authorizePaymentLoyaltyPoints">
                    <ReactSwitch
                        disabled={!isActivation}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={sofaveraActivation()}
                        onChange={(e) => {}}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                    />
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3 ml-3 px-5">
                <div className="ml-5">
                    {t("Authorize payment by loyalty points")}
                </div>
                <div className="float-right mr-4 cac_icn_authorizePaymentLoyaltyPoints">
                    <ReactSwitch
                        disabled={!isActivation}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={isAuthorized}
                        onChange={(e) => setIsAuthorized(e)}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                    />
                </div>
            </div>

            <div>
                <div className="d-flex align-items-center justify-content-between mt-5">
                    <StyledH2
                        style={{
                            font: "normal normal 600 20px/27px Nunito Sans",
                            color: "#000000",
                            opacity: "1",
                        }}
                        className="ml-5 pt-3"
                    >
                        {t("Godia loyalty")}
                    </StyledH2>
                    <div className="float-right mr-4 cac_icn_loyaltyAccountActivation">
                        <ReactSwitch
                            disabled={true}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={godia.ActivationGodia === 1}
                            onChange={() => {}}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={55}
                            height={20}
                        />
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-3 ml-3 px-5">
                    <div className="ml-5">{t("Recompences")}</div>
                    <div className="float-right mr-4 cac_icn_authorizePaymentLoyaltyPoints">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="godiaParamavantages"
                            id="authorizePayment"
                            disabled={godia.ActivationGodia === 0}
                            checked={godia.Paramavantages === 1}
                            onChange={() => handleGodiaParamChange(1)}
                        />
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-3 ml-3 px-5">
                    <div className="ml-5">
                        {t("Authorize payment by loyalty points")}
                    </div>
                    <div className="float-right mr-4 cac_icn_authorizePaymentLoyaltyPoints">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="godiaParamavantages"
                            id="authorizePayment"
                            disabled={godia.ActivationGodia === 0}
                            checked={godia.Paramavantages === 2}
                            onChange={() => handleGodiaParamChange(2)}
                        />
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-between mt-4 ml-3 px-5">
                    <div className="ml-5">{t("Interconnection Key")}</div>
                    <div
                        className="float-right mr-4 cac_icn_authorizePaymentLoyaltyPoints"
                        style={{ width: "30%" }}
                    >
                        <Input
                            disabled={godia.ActivationGodia === 0}
                            type="text"
                            className="form-control epb_inp_timeAS mr-2"
                            value={godia.licenceGodia}
                            invalid={godia.licenceGodia !== "" && !isValid}
                            onChange={(e) =>
                                handleInterconnectionKey(e.target.value)
                            }
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
